import _ from "lodash";

const assets = {
  bg: "/images/preview/staticmedia.jpg",
  blue_bg: require("./images/blue_4x5.jpg"),
  red_bg: require("./images/red_4x5.jpg"),
  distance_1920: require("./videos/Background_16x9.webm"),
  distance_1200: require("./videos/shot_speed_1200x1500.webm"),
  fastest_scater_1920: require("./videos/Background_16x9.webm"),
  fastest_scater_1200: require("./videos/shot_speed_1200x1500.webm"),
  shot_speed_1920: require("./videos/Background_16x9.webm"),
  shot_speed_1200: require("./videos/shot_speed_1200x1500.webm"),
  penny_del: require("../../../assets/logos/penny-del-logo-season.png"),
};

export default assets;
